module.exports = __webpack_public_path__ + "static/media/users-icon.63aae4dd.svg";